<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SB31Ni/tc-custom/9781480457072.jpg?1733120062771" alt="This image is the cover for the book Cheaper by the Dozen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cheaper by the Dozen
      </h1>
      <p class="bookDescription body article font2">
        <b>The #1 <i>New York Times</i>–bestselling classic: A hilarious memoir of two parents, twelve kids, and “</b><b>a life of cheerfully controlled chaos” (<i>The New York Times</i>).</b><br/><br/> Translated into more than fifty languages, <i>Cheaper by the Dozen </i>is the unforgettable story of the Gilbreth clan as told by two of its members. In this endearing, amusing memoir, siblings Frank Jr. and Ernestine capture the hilarity and heart of growing up in an oversized family.<br/><br/> Mother and Dad are world-renowned efficiency experts, helping factories fine-tune their assembly lines for maximum output at minimum cost. At home, the Gilbreths themselves have cranked out twelve kids, and Dad is out to prove that efficiency principles can apply to family as well as the workplace.<br/>  <br/> The heartwarming and comic stories of the jumbo-size Gilbreth clan have delighted generations of readers, and will keep you and yours laughing for years.<br/>  <br/><i>This ebook features an illustrated biography including rare photos from the authors’ estates.</i><br/>    
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank B. Gilbreth, Ernestine Gilbreth Carey
      </h2>
      
      <p class="authorDescription body article">Frank B. Gilbreth Jr. (1911&ndash;2001) served as a lieutenant commander in the US Navy during World War II, earning the Bronze Star and Air Medal for his valor in the campaigns in the South Pacific. After the war, he worked for the <I>Post and Courier</I> of Charleston, South Carolina, as a columnist and reporter. His books include <I>How to Be a Father </I>and <I>Time Out for Happiness</I>, and the classics <I>Cheaper by the Dozen</I> and <I>Belles on Their Toes</I>, both coauthored with his sister Ernestine Gilbreth Carey.<BR /> In 1950, Frank and Ernestine Gilbreth were corecipients of the French International Humor Award for <I>Cheaper by the Dozen</I>.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Intergated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06d49986